import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4261222e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "participation-history-item" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = {
  key: 0,
  class: "desc"
}
const _hoisted_8 = { class: "action" }

import { IUserRequest } from '@/types/user-request';
import { request, confirm } from '@/utils';
import { useI18n } from 'vue-i18n';
import { USER_REQUEST_STATE_MAP } from '@/constants';
import { computed } from 'vue';

interface Props {
  modelValue: IUserRequest,
}

interface Emits {
  (event: 'update:model-value', modelValue: IUserRequest): void;
  (event: 'update'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ["update:model-value", "update"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', modelValue: IUserRequest): void;
  (event: 'update'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: IUserRequest,
}



const { t, locale } = useI18n();
const stateClass = computed(() => {
  const state = props.modelValue.state;
  if (['approved', 'wait_listed'].includes(state)) {
    return 'green';
  }
  return 'gray';
});

const showCancel = computed(() => {
  const state = props.modelValue.state;
  return ['pending', 'approved', 'wait_listed'].includes(state);
});

 async function handleCancel() {
   await confirm(t('close_confirm_text'), { class: `modal-record-item-delete-${locale.value}` });
   await request.put(`user_requests/${props.modelValue.id}/close_participation_request`);
   emits('update:model-value', {
     ...props.modelValue,
     state: 'closed'
   });
 }

async function handleReParticipation() {
  await confirm(t('re_confirm_text'), { class: `modal-record-item-delete-${locale.value}` });
  await request.post(`programs/${props.modelValue.target_id}/participate`);
  emits('update');
}

return (_ctx: any,_cache: any) => {
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.modelValue.target.image?.url,
        class: "cover"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["status", _unref(stateClass)])
        }, _toDisplayString(_unref(USER_REQUEST_STATE_MAP)[__props.modelValue.state]), 3),
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.modelValue.target.name), 1),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t('Participation date')) + ": ", 1),
          _createVNode(_component_AppTimeFormat, {
            time: __props.modelValue.created_at,
            format: "YYYY-MM-DD"
          }, null, 8, ["time"])
        ]),
        (__props.modelValue.collection_challenge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('collection_challenge')) + " : " + _toDisplayString(__props.modelValue.collection_challenge), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_unref(showCancel))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn cancel",
            onClick: handleCancel
          }, _toDisplayString(_unref(t)('Cancel')), 1))
        : _createCommentVNode("", true),
      (__props.modelValue.state === 'closed')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn re",
            onClick: handleReParticipation
          }, _toDisplayString(_unref(t)('Re-participation')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})